import { Alert, Stack, Typography } from "@mui/material";
import CategoriesEditor from "./edit-categories/CategoriesEditor";
import useFundraisingDetailsPageContext from "./useFundraisingDetailsPageContext";

const FundraisingCategoriesConfig = () => {
  const { isContentEditable, fundraisingCategories, refreshCategories, refreshFundraising } =
    useFundraisingDetailsPageContext();

  const handleCategoriesUpdated = () => {
    refreshCategories();
    refreshFundraising();
  };

  return (
    <Stack spacing={3} sx={{ flex: 1, py: 2.5 }}>
      <Stack spacing={0.5} sx={{ pt: 2 }}>
        <Typography variant="subtitle1">Access Categories</Typography>
        <Typography variant="caption" color="textSecondary">
          Define categories to control contact access to documents.
        </Typography>
      </Stack>
      <Alert severity="info">Access categories are shared across all fundraising data rooms.</Alert>
      <CategoriesEditor
        categories={fundraisingCategories}
        readOnly={!isContentEditable}
        onCreated={handleCategoriesUpdated}
        onUpdated={handleCategoriesUpdated}
        onDeleted={handleCategoriesUpdated}
      />
    </Stack>
  );
};

export default FundraisingCategoriesConfig;
